export const APP_ID=1262395932;
export const SERVER_SECRET="f5ce03ab694962ebefdec72de916f20e";